import yup from './yup'
import { urlRegExp } from './index'

export const vendorFormSchema = yup.object().shape({
  email: yup
    .string()
    .email('Email is not valid')
    .label('Email')
    .trimmedRequired('Email is required'),
  name: yup.string().label('Exhibitor name').trimmedRequired('Exhibitor name is required'),
  booth: yup.string().label('Booth No').trimmedRequired('Booth No is required'),
  websiteUrl: yup
    .string()
    .matches(urlRegExp, 'Website URL must be a valid URL')
    .label('Website URL'),
  intro: yup.string().label('Introduction'),
  message: yup.string().label('Message')
})
